// extracted by mini-css-extract-plugin
export default {"wrap":"Separator_wrap__pDkyC"};